import { render, staticRenderFns } from "./LiveBarrages.vue?vue&type=template&id=74030141&scoped=true&"
import script from "./LiveBarrages.vue?vue&type=script&lang=js&"
export * from "./LiveBarrages.vue?vue&type=script&lang=js&"
import style0 from "./LiveBarrages.vue?vue&type=style&index=0&id=74030141&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74030141",
  null
  
)

export default component.exports